import React from 'react'
import { Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'
import clientData from '../../utils/client-data'
import GiftCardsList from '../shared/gift-cards-list'
import { GiftCardsContent } from '../shared/glamorous-style'
import glamorous from 'glamorous'
import { withApollo, graphql } from 'react-apollo'
import getProductsInCategory from '../../graphql/getProductsInCategory'
import { trackImpression } from '../../utils/analytics'
import { handleSessionError } from '../../utils/error-tracking'
import { flowRight as compose } from 'lodash'
import Button from '../shared/button'
import getAllProducts from '../../graphql/getAllProducts'
import GoBackLink from '../shared/go-back-link'
import { Message } from '@paypalcorp/worldready-react'

const Title = glamorous.h1({
  textAlign: 'center',
  color: '#4a4a4a',
  margin: 'auto',
  paddingTop: '42px',
  paddingBottom: '50px',
  '@media only screen and (max-width: 768px)': {
    padding: '20px 0',
  },
})

const ButtonContainer = glamorous.section('vx_btn-container', {
  margin: '0 auto',
  width: '270px',
  padding: '40px 0',
  '@media only screen and (max-width: 768px)': {
    //padding: 0,
  },
})

const ContainerStyle = {
  background: 'white',
  maxWidth: '929px',
}

class GiftCardCategory extends React.Component {
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
    data: PropTypes.shape({
      loading: PropTypes.bool,
      error: PropTypes.object,
      getProductsInCategory: PropTypes.object,
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }),
    }),
    client: PropTypes.object,
    allProducts: PropTypes.shape({
      getAllProducts: PropTypes.shape({
        all_a_z: PropTypes.array,
      }),
      loading: PropTypes.bool,
    }),
  }

  constructor(props) {
    super(props)
    this.state = {
      searchFilter: () => true,
      inContextFlow: clientData.inContextFlow,
      showAllCards: false,
    }

    this.goToAll = this.goToAll.bind(this)
  }

  componentDidMount() {
    this.props.client.writeData({ data: { onReviewPage: false } })

    trackImpression(
      'main:consumer:gifts:home:',
      `main:consumer:gifts:home:category:${encodeURIComponent(
        this.props.match.params.name,
      )}::`,
    )

    window.scrollTo(0, 0)
  }

  goToAll = () => {
    this.setState((prevState) => ({
      ...prevState,
      showAllCards: !prevState.showAllCards,
    }))
  }

  render() {
    const { inContextFlow, showAllCards } = this.state
    const { data, allProducts } = this.props

    if (data.loading || (allProducts && allProducts.loading)) {
      return (
        <div className="vx_has-spinner-large" style={{ paddingTop: '400px' }} />
      )
    }
    if (this.props.data.error) {
      handleSessionError(this.props.data.error)
      return <Redirect to="/error" />
    }

    const categoryProducts = this.props.data.getProductsInCategory

    const path = this.props.location.pathname.split('/')
    // no matching category, redirect to categories/occasions page
    if (categoryProducts.category_name === '') {
      return path[1] === 'categories' ? (
        <Redirect to="/categories" />
      ) : (
        <Redirect to="/occasions" />
      )
    }

    return (
      <div>
        {!inContextFlow && (
          <Title className="vx_text-2">{categoryProducts.category_name}</Title>
        )}

        <div id="gift-card-category">
          {inContextFlow && (
            <GoBackLink
              path="../../../myaccount/transfer/homepage/send/preview"
              pagename="main:consumer:gifts:home"
            />
          )}
          <div
            className="container"
            style={inContextFlow ? ContainerStyle : {}}
          >
            {inContextFlow && (
              <Title className="vx_text-2">
                <Message id="pages/all-gift-cards.categories.p2ptitle" />
              </Title>
            )}
            <GiftCardsContent>
              <div id="gift-cards-a-z">
                <GiftCardsList
                  basepath="../"
                  title={
                    inContextFlow ? (
                      ''
                    ) : (
                      <Message id="pages/all-gift-cards.allgiftcards.giftcardsAZ" />
                    )
                  }
                  items={categoryProducts.all_a_z.filter(
                    this.state.searchFilter,
                  )}
                />
              </div>
            </GiftCardsContent>
            {inContextFlow && (
              <React.Fragment>
                {!showAllCards && (
                  <ButtonContainer>
                    <Button
                      text={`${(
                        <Message id="pages/all-gift-cards.categories.browse" />
                      )} ${allProducts.getAllProducts.all_a_z.length} ${(
                        <Message id="pages/all-gift-cards.categories.seeAll" />
                      )}`}
                      type="secondary"
                      handleClick={this.goToAll}
                      pageName="main:consumer:gifts:home"
                    />
                  </ButtonContainer>
                )}
                {showAllCards && (
                  <GiftCardsContent>
                    <div id="gift-cards-a-z">
                      {!this.props.allProducts.loading && (
                        <GiftCardsList
                          basepath="../"
                          title={
                            <Message id="pages/all-gift-cards.allgiftcards.giftcardsAZ" />
                          }
                          items={allProducts.getAllProducts.all_a_z}
                          centerAlign={true}
                        />
                      )}
                    </div>
                  </GiftCardsContent>
                )}
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    )
  }
}

function resolveRouteAliases(pathname) {
  const aliases = clientData.routeAliases[clientData.locality.country] || {}
  const route = pathname.slice(1)
  return aliases[route] || route
}

const GiftCardCategoryWithData = compose(
  withApollo,
  graphql(getProductsInCategory, {
    options: (ownProps) => {
      return {
        variables: {
          urlKey: resolveRouteAliases(ownProps.location.pathname),
          inContextFlow: clientData.inContextFlow,
        },
      }
    },
  }),
  graphql(getAllProducts, {
    name: 'allProducts',
    skip: (ownProps) => !ownProps.data.variables.inContextFlow,
  }),
)(GiftCardCategory)

export default GiftCardCategoryWithData
